import React from 'react'
import { Hit } from "../../store/ProductStore"
import { AlcoholRestrictionOverlay } from '../alcohol-restriction-overlay'
import { UnavailableProductsOverlay } from '../unavailable-overlays'
import { RestrictedProductsOverlay } from '../restricted-products-overlay'
import { getUnavailableProductReason } from '../../utils/utils'


interface IProductOverlayProps {
  isAlcoholRestriction?: boolean
  isUnavailable?: boolean
  isRestricted?: boolean
  onAlcoholLearnMoreClick: () => void
  hit: Hit
}

export const ProductOverlay = (props: React.PropsWithChildren<IProductOverlayProps>) => {
  if (props.isAlcoholRestriction) {
    return <AlcoholRestrictionOverlay onLearnMoreClick={props.onAlcoholLearnMoreClick} />
  }

  if (props.isRestricted) {
    return <RestrictedProductsOverlay hit={props.hit} />
  }

  if (props.isUnavailable) {
    return <UnavailableProductsOverlay reasonForDisabledStatus={getUnavailableProductReason(props.hit)} />
  }

  return null
}